/** @format */

export const Canon = {
    id: 6096,
    name: 'Canon',
};

export const Nikon = {
    id: 6097,
    name: 'Nikon',
};

export const Sony = {
    id: 6100,
    name: 'Sony',
};

export const Fujifilm = {
    id: 6101,
    name: 'Fujifilm',
};

export const Panasonic = {
    id: 6098,
    name: 'Panasonic',
};

export const Olympus = {
    id: 6099,
    name: 'Olympus',
};

export const Sigma = {
    id: 6112,
    name: 'Sigma',
};

export const Leica = {
    id: 6102,
    name: 'Leica',
};

export const Hasselblad = {
    id: 6103,
    name: 'Hasselblad',
};

export const DJI = {
    id: 6211,
    name: 'DJI',
};

export const REDDigitalCinema = {
    id: 6106,
    name: 'RED Digital Cinema',
};

export const popularBrands = [
    Canon,
    Nikon,
    Sony,
    Fujifilm,
    Panasonic,
    Olympus,
    Sigma,
    Leica,
    Hasselblad,
    DJI,
    REDDigitalCinema,
];
export enum Department {
    NEW = 'New',
    USED = 'Used',
}

export enum TaxonomyTermType {
    CATEGORY = 'Category',
    CAROUSEL = 'Carousel',
    BRAND = 'Brand',
}
